import { Snackbar as MuiSnackbar, SnackbarProps } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

interface Props extends SnackbarProps {
  className?: string;
}

const SnackbarImpl = React.forwardRef<HTMLDivElement, Props>(
  ({ className, ...props }, ref) => {
    return <MuiSnackbar className={className} ref={ref} {...props} />;
  }
);

/**
 * Customized MUI Snackbar component.
 *
 * It inherits all properties of a MUI Snackbar component.
 */
export const Snackbar = muiStyled(SnackbarImpl)(({ theme }) => css``);

export default Snackbar;
